export { default } from './PageHistoricalFigures.vue'
